import algoliasearch from "algoliasearch/lite";
import React, { Component } from "react";
import { format, fromUnixTime } from "date-fns";
import { orderBy } from "lodash";
import {
  InstantSearch,
  Hits,
  Pagination,
  Snippet,
  ClearRefinements,
  Configure,
  CurrentRefinements,
  connectSearchBox,
  connectStats,
  connectCurrentRefinements
} from "react-instantsearch-dom";
import {
  connectStateResults,
  connectRefinementList
} from "react-instantsearch-dom";
import PropTypes from "prop-types";
import "./App.css";

const searchClient = algoliasearch(
  "H7I59Z3ULG",
  "9ec9b0dde3e9881bc09f32827e2b7c92"
);

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <InstantSearch
          indexName={"algolia_index"}
          searchClient={searchClient}
          style={{ width: "100%" }}
        >
          <div className="search-strip bg--dark-blue-b">
            <div className="search-strip--inner pt--05 pb--05">
              <div className="ais-InstantSearch">
                <CustomSearchBox />
              </div>
            </div>
          </div>
          <Results
            us={window.drupalSettings.path.currentLanguage === "en-us"}
          />
        </InstantSearch>
      </React.Fragment>
    );
  }
}

const Results = connectStateResults(({ searchState, us }) =>
  searchState && searchState.query ? (
    <div className="container" style={{ marginTop: "2rem" }}>
      <div className="span-8 push-4">
        <ClearSearch clearsQuery />
        <CustomStats />
        <CurrentRefinements
          transformItems={items => {
            if (items.length < 1) {
              return items;
            }
            return items.map(refinement => {
              refinement.label = refinement.label.replace("_title:", "");
              refinement.label =
                refinement.label.charAt(0).toUpperCase() +
                refinement.label.slice(1);
              return refinement;
            });
          }}
        />
        <Hits hitComponent={Hit} />
        <Pagination />
      </div>
      <div className="span-4 pull-12">
        <ClearRefinements />

        <h2 className="font--light">Page types</h2>
        <CustomRefinementList attribute="type" />

        <h2 className="font--light">Sectors</h2>
        <CustomRefinementList attribute="sectors_title" />

        <h2 className="font--light">Services</h2>
        <CustomRefinementList attribute="services_title" />

        <Configure
          hitsPerPage={8}
          attributesToSnippet={["rendered_item"]}
          filters={
            us
              ? `langcode:en-us OR langcode:und`
              : `langcode:en OR langcode:und`
          }
        />
      </div>
    </div>
  ) : null
);

const ClearSearchComponent = ({ items, refine }) => {
  const reset = () => {
    refine(items);
    document.getElementsByClassName("search-strip")[0].style.display = "none";
    document
      .getElementsByClassName("menu-search-trigger")[0]
      .classList.remove("is-open");
  };

  return (
    <button
      onClick={reset}
      disabled={!items.length}
      className="button--clear fg--black"
      style={{
        padding: 0,
        display: "flex",
        alignItems: "center",
        float: "right"
      }}
    >
      Close{" "}
      <svg
        viewBox="0 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        style={{ width: "1.25rem", marginLeft: ".5rem" }}
      >
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="#000000"
          fill-rule="evenodd"
        >
          <g id="icon-shape">
            <polygon
              id="Combined-Shape"
              points="10 8.58578644 2.92893219 1.51471863 1.51471863 2.92893219 8.58578644 10 1.51471863 17.0710678 2.92893219 18.4852814 10 11.4142136 17.0710678 18.4852814 18.4852814 17.0710678 11.4142136 10 18.4852814 2.92893219 17.0710678 1.51471863 10 8.58578644"
            ></polygon>
          </g>
        </g>
      </svg>
    </button>
  );
};

const ClearSearch = connectCurrentRefinements(ClearSearchComponent);

const Stats = ({ nbHits }) => (
  <React.Fragment>
    {nbHits < 1 && <p>Sorry, your search returned no results.</p>}
    {nbHits > 0 && (
      <p>
        <strong style={{ color: "#455c8a" }}>{nbHits}</strong> results found
      </p>
    )}
  </React.Fragment>
);

const CustomStats = connectStats(Stats);

const Hit = props => {
  const { hit } = props;
  const displayType = hit.type.charAt(0).toUpperCase() + hit.type.slice(1);
  const changedDate = fromUnixTime(hit.created);

  const lang = hit._highlightResult.langcode.value;

  return (
    <div className="search-results__hit mb--2">
      {displayType === "Insight" && (
        <p className="mb--0 font--semibold text--upper">
          <small>{format(changedDate, "dd MMM yyyy")}</small>
        </p>
      )}

      {lang === "und" && (
        <h3 className="search-results__hit-title font--regular mb--0">
          <a
            href={`${
              window.drupalSettings.path.currentLanguage === "en-us"
                ? "/us"
                : "/uk"
            }${hit.url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {hit.title}
          </a>
        </h3>
      )}

      {lang !== "und" && (
        <h3 className="search-results__hit-title font--regular mb--0">
          <a href={`${hit.url}`} target="_blank" rel="noopener noreferrer">
            {hit.title}
          </a>
        </h3>
      )}

      {hit.offices_title && displayType === "Profile" && (
        <div
          className="mb--05 font--semibold font--sm"
          style={{ marginTop: ".25rem" }}
        >
          {hit.offices_title}
        </div>
      )}

      <div className="search-results__hit-snippet mb--05">
        <Snippet attribute="rendered_item" hit={hit} />
      </div>

      <div className="search-results__hit-type">
        <div
          className="font--sm"
          style={{
            display: "inline-block",
            backgroundColor: "#fbfbfb",
            border: "1px solid #eeeeee",
            padding: ".1rem .5rem"
          }}
        >
          {displayType === "Rich_page" && "Other"}
          {displayType === 'Campaign_page' && 'Initiative'}
          {displayType !== "Rich_page" && displayType !== "Campaign_page" &&
            displayType.charAt(0).toUpperCase() +
              displayType.replace("_", " ").slice(1)}
        </div>
      </div>
    </div>
  );
};

Hit.propTypes = {
  hit: PropTypes.object.isRequired
};

const SearchBox = ({ currentRefinement, isSearchStalled, refine }) => {
  const keyDown = event => {
    if (event.which === 13) {
      event.preventDefault();
      event.stopPropagation();
    }
  };
  return (
    <form
      noValidate
      action=""
      role="search"
      className="span-12 search-strip--form"
    >
      <label htmlFor="site-search" className="search-strip--label">
        Enter your keywords
      </label>
      <input
        type="search"
        name="site-search"
        value={currentRefinement}
        onChange={event => refine(event.currentTarget.value)}
        onKeyDown={keyDown}
        className="search-strip--input"
      />
      {isSearchStalled ? "My search is stalled" : ""}
    </form>
  );
};

const CustomSearchBox = connectSearchBox(SearchBox);

const WbdRefinementList = ({ items, refine }) => (
  <ul className="ais-RefinementList-list">
    {orderBy(items, "label").map(item => (
      <li key={item.label}>
        <label
          href="#"
          style={{
            fontWeight: item.isRefined ? "bold" : "",
            marginBottom: ".25rem"
          }}
          onClick={event => {
            event.preventDefault();
            refine(item.value);
          }}
        >
          {item.label === "rich_page" && "Other"}
          {item.label === 'campaign_page' && 'Initiative'}
          {item.label !== "rich_page" && item.label !== "campaign_page" &&
            item.label.charAt(0).toUpperCase() +
              item.label.replace("_", " ").slice(1)}{" "}
          <span
            className="ais-RefinementList-count"
            style={{ color: "#455c8a" }}
          >
            {item.count}
          </span>
        </label>
      </li>
    ))}
  </ul>
);

const CustomRefinementList = connectRefinementList(WbdRefinementList);

export default App;
